/**
 * Created by rkotha on 8/2/2017.
 */
(function() {
    'use strict';

    angular
        .module('nasracApp')
        .config(['$compileProvider', function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
        }])
        .controller('ConfigureSiteAdminMainController', ConfigureSiteAdminMainController);

    // AstbBillingController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];
    ConfigureSiteAdminMainController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$sce', 'siteAdminEntity', 'piwikEntity','NasracWebContent'];

	    function ConfigureSiteAdminMainController($scope, Principal, LoginService,
			$state, $sce, siteAdminEntity, piwikEntity, NasracWebContent) {
	    var vm = this;
		vm.account = null;
		vm.isAuthenticated = null;
		vm.login = LoginService.open;
		vm.register = register;
		$scope.$on('authenticationSuccess', function() {
			getAccount();
		});

		var entity = siteAdminEntity[0];
		vm.nasrac_web_content = entity;
		if (entity !== undefined) {
			vm.trustedHtml = $sce.trustAsHtml(entity.content);
			vm.tinymceModel = entity.content;
		}
		
		var pEntity = piwikEntity[0];
		console.log(JSON.parse(pEntity.content));
		vm.siteContent = JSON.parse(pEntity.content);
		vm.editMode = false;

		
		vm.updateContents = function() {
			if (entity === undefined) {
				entity = {};
				entity.content = {};
			}
			pEntity.content = JSON.stringify(vm.siteContent);
			NasracWebContent.update(pEntity);
			
			entity.content = vm.tinymceModel;
			NasracWebContent.update(entity, onSaveSuccess, onSaveError);
			
			
			vm.editMode = false;
		};

		vm.cancelEditor = function() {
			vm.editMode = false;
		}

		vm.openEditor = function() {
			vm.editMode = true;
		}

		getAccount();

		function getAccount() {
			Principal.identity().then(function(account) {
				vm.account = account;
				vm.isAuthenticated = Principal.isAuthenticated;
			});
		}

		function register() {
			$state.go('register');
		}

		function onSaveSuccess(result) {
			vm.editMode = false;
			$state.go('siteadminreports', {}, {
				reload : true
			});
		}

		function onSaveError() {
			vm.editMode = true;
		}

	}

})();
